import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import { Alert } from "components/elements";
import dayjs from "dayjs";
import { generateRandomString } from "utils/helper";
import * as masterDataServices from "features/masterData/services/optionsApi";
import * as services from "../services/employeeApi";
import { setCurrentEmployee, setCurrentEmployeeOnEdit, setIsLoading } from "../slices/employeeSlice";
const DATE_FIELDS = [
  "passportIssueDate",
  "passportExpireDate",
  "visaIssueDate",
  "visaExpireDate",
  "workPermitIssueDate",
  "workPermitExpireDate",
];

const toDayjsFields = (data = {}) => {
  const result = { ...data };
  DATE_FIELDS.forEach((field) => {
    if (result[field]) {
      result[field] = dayjs(result[field]);
    }
  });
  return result;
};
const useEmployeeEdit = (nav = true) => {
  const dispatch = useDispatch();
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [isVisible, setIsVisible] = useState(false);
  const [countryOptions, setCountryOptions] = useState([]);
  const [visaTypeOptions, setVisaTypeOptions] = useState([]);

  const currentCompany = useSelector((state) => state.company.currentCompany);
  const isLoading = useSelector((state) => state.employee.isLoading);
  const currentEmployee = useSelector((state) => state.employee.currentEmployee);
  const currentEmployeeOnEdit = useSelector((state) => state.employee.currentEmployeeOnEdit);

  const getCountryOptions = useCallback(async () => {
    try {
      const response = await masterDataServices.getCountryOptions({
        requestId: generateRandomString(),
      });
      setCountryOptions(response.data);
    } catch (error) {
      Alert({ type: "error", resultObject: error });
    }
  }, []);

  const getVisaTypeOptions = useCallback(async () => {
    try {
      const response = await masterDataServices.getVisaType();
      setVisaTypeOptions(response.data);
    } catch (error) {
      Alert({ type: "error", resultObject: error });
    }
  }, []);

  useEffect(() => {
    getCountryOptions();
  }, [getCountryOptions]);

  useEffect(() => {
    if (currentCompany != null) {
      getVisaTypeOptions();
    }
  }, [currentCompany, getVisaTypeOptions]);
  // console.log("employee", currentEmployee);
  const [selectedMenu, setMenu] = useState();
  // console.log("selectedMenu", selectedMenu);

  useEffect(() => {
    const pathname = location.pathname;
    const splitedPathname = pathname.split("/");
    if (splitedPathname.length > 0) {
      const lastSegment = splitedPathname[splitedPathname.length - 1];
      setMenu(lastSegment || 'employee_info');
    }
  }, [location.pathname]);

  const getEmployee = useCallback(
    async ({ employeeId, visible = false, edit = false }) => {
      try {
        dispatch(setIsLoading(true));
        const response = await services.getGeneralInfomation({
          requestId: generateRandomString(),
          companyId: currentCompany,
          visible: visible,
          employeeId,
          isEdit: edit
        });
        dispatch(setCurrentEmployee(toDayjsFields(response.data) || {}));
      } catch (error) {
        Alert({ type: "error", resultObject: error });
      } finally {
        dispatch(setIsLoading(false));
      }
    },
    [currentCompany]
  );
  const getEmployeeOnEdit = useCallback(
    async ({ employeeId, visible = false, edit = false }) => {
      try {
        dispatch(setIsLoading(true));
        const response = await services.getGeneralInfomation({
          requestId: generateRandomString(),
          companyId: currentCompany,
          visible: visible,
          employeeId,
          isEdit: edit
        });
        dispatch(setCurrentEmployeeOnEdit(toDayjsFields(response.data) || {}));
      } catch (error) {
        Alert({ type: "error", resultObject: error });
      } finally {
        dispatch(setIsLoading(false));
      }
    },
    [currentCompany]
  );

  const onSelectMenu = useCallback(
    (menu) => {
      console.log("lo", location);
      if (nav) {
        navigate(`/employee/${params.id}/${menu}`, { state: { ...location.state } });
      }
    },
    [params.id, navigate, nav]
  );

  useEffect(() => {
    if (params.id && currentCompany) {
      getEmployee({ employeeId: params.id, visible: false, edit: false });

      const currentPath = location.pathname;
      const isRootEmployeePath = currentPath === `/employee/${params.id}` || currentPath === `/employee/${params.id}/`;

      if (isRootEmployeePath) {
        onSelectMenu('employee_info');
      }
    }
  }, [currentCompany, params.id, getEmployee, location.pathname]);

  return {
    id: params.id,
    isLoading,
    currentEmployee,
    selectedMenu,
    onSelectMenu,
    getEmployee,
    isVisible,
    setIsVisible,
    getEmployeeOnEdit,
    currentEmployeeOnEdit,
    countryOptions,
    visaTypeOptions,
  };
}

export default useEmployeeEdit;
